import * as React from 'react'

import { GlobeIcon, ImageIcon, PlusIcon } from 'lucide-react'

import { Button } from '~/client/src/shared/components/Button/Button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '~/client/src/shared/components/shadcn-ui/dropdown-menu'
import Localization from '~/client/src/shared/localization/LocalizationManager'

interface IProps {
  onCreateView: () => void
  onCreateWhiteboard: () => void
}

export const MapViewsSidebarCreateMenu: React.FC<IProps> = ({
  onCreateView,
  onCreateWhiteboard,
}) => (
  <DropdownMenu>
    <DropdownMenuTrigger
      render={
        <Button variant="outline" size="lg">
          <PlusIcon data-icon="inline-start" aria-hidden="true" />
          {Localization.translator.newMapView}
        </Button>
      }
    />
    <DropdownMenuContent align="start" sideOffset={4}>
      <DropdownMenuItem onClick={onCreateView}>
        <GlobeIcon aria-hidden="true" />
        {Localization.translator.createNewView}
      </DropdownMenuItem>
      <DropdownMenuItem onClick={onCreateWhiteboard}>
        <ImageIcon aria-hidden="true" />
        {Localization.translator.createNewWhiteboard}
      </DropdownMenuItem>
    </DropdownMenuContent>
  </DropdownMenu>
)
